module.exports = __webpack_public_path__ + "img/Edelstahlbalkonbruestung.0fad78a9.jpg";